import { AddNotesDialog } from './components/dialogs/add-notes-dialog';
import { NgModule} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SharedTranslateModule } from '../app/shared-translate.module';
import { SpinnerModule } from '../app/spinner.module';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        SharedTranslateModule,
        SpinnerModule
    ],  
    declarations: [
        AddNotesDialog
    ],
    entryComponents: [
        AddNotesDialog
        ], 
    exports: [
        AddNotesDialog
    ]
})
  
export class AddNotesDialogModule {}
